module.exports = __webpack_public_path__ + "static/img/Richmond.cd4b9cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Richmond.jpg
// module id = Rldu
// module chunks = 1